export const MODAL_ID = 'lead-filter-modal';
